<template>
  <div class="compressed-content">
    <h3 class="page-question">Do you know your highest triglyceride level from previous testing?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.highestTriglycerideLevel">
      <b-form-radio v-model="survey.bloodBiochemistry.triglycerides.highestTriglycerideLevel" name="triglyceride"
                    :value=triglycerideLevel.Unknown>
        Don’t know or never tested
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.triglycerides.highestTriglycerideLevel" name="triglyceride"
                    :value=triglycerideLevel.Low>
        Low = less than 150 mg/dL
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.triglycerides.highestTriglycerideLevel" name="triglyceride"
                    :value=triglycerideLevel.Elevated>
        Elevated = between 150-175 mg/dL
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.triglycerides.highestTriglycerideLevel" name="triglyceride"
                    :value=triglycerideLevel.High>
        High = 175 mg/dL or higher
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import triglycerideLevel from "enums/triglyceride-level";

  export default {
    mixins: [formMixin],
    data() {
      return {
        triglycerideLevel: triglycerideLevel,
      };
    },

    validations: {
      highestTriglycerideLevel: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      highestTriglycerideLevel() { return this.survey.bloodBiochemistry.triglycerides.highestTriglycerideLevel; }
    }
  };
</script>